<div class="chat-container">

    @if(isSessionIdVisible && llmSessionId) {
        <span class="sessionId">Session ID: {{ llmSessionId }}</span>
    }

    <!-- Sessions quota exceeded -->
    @if (this.sessionQuotaStatus && this.sessionQuotaStatus.limitReached) {
    <span class="limit-message">Daily limit reached. You can’t start new sessions, but you can still view your existing ones.</span>
    }

    <!-- Loading history messages -->
    @if (isLoadingHistoryMessages) {
    <div class="chat-messages chat-messages-loading" #messagesContainer>
      <p class="loading-messages">Retrieving your chat, please wait.</p>
    </div>
    <div class="chat-input">
      <sabis-chatbot-input #inputComponent [hasActiveSession]="hasActiveSession" [isOutOfPrompts]="isOutOfPrompts"
        [isOutOfSessions]="isOutOfSessions"
        [maxChars]="maxChars" [disclaimerMessage]="disclaimerMessage" [canAddEquation]="canAddEquation"
        [isConnectionEstablished]="isConnectionEstablished" (sendMessage)="onSendMessage()" (cancelEdit)="onCancelEdit($event)"
        [isLandingPage]="false" [isChatbotModeActive]="isChatbotModeActive" [chatbotModes]="chatbotModes"></sabis-chatbot-input>
    </div>
    }
    
    <!-- Failed to load history messages -->
    @if (isHistoryLoadingFailed) {
    <div class="history-loading-error">
        <p class="error-message">Connection lost. The conversation couldn’t load.</p>
        <sabis-retry-button [title]="'Retry'" (retryClick)="retryLoadingHistory()"></sabis-retry-button>
    </div>
    }

    <!-- Messages Area -->
    @if (!isLoadingHistoryMessages && !isHistoryLoadingFailed && messages.length > 0) {
        <div class="chat-messages" #messagesContainer appDisableCopy>
            @for (msg of messages; track msg.id) {
            @if (msg.sender === 'user') {
            <sabis-chatbot-user-message #userMessage [message]="msg" (resend)="onResendMessage($event)" (edit)="onEditMessage($event)" />
            } @else {
            <sabis-chatbot-bot-message [message]="msg" (regenerate)="onRegenerateMessage($event)"
            (contentClick)="onContentClick($event)" />
            }
            }
        </div>

        <!-- Error message Area -->
        @if (this.sessionQuotaStatus?.isLastSession && this.promptQuotaStatus?.limitReached ) {
        <span class="limit-message">
            Daily limit reached. You can’t start new sessions, but you can still view your existing ones.
        </span>
        } @else if (this.promptQuotaStatus?.limitReached) {
        <span class="limit-message">
            You’ve reached the end of this chat. Start a new one to continue learning!
        </span>
        }

    <!-- Input Area -->
    <div class="chat-input">
        <sabis-chatbot-input #inputComponent [hasActiveSession]="hasActiveSession" [isOutOfPrompts]="isOutOfPrompts" [isOutOfSessions]="isOutOfSessions"
                             [maxChars]="maxChars" [disclaimerMessage]="disclaimerMessage" [canAddEquation]="canAddEquation"
                             [isConnectionEstablished]="isConnectionEstablished" (sendMessage)="onSendMessage()" (cancelEdit)="onCancelEdit($event)"
                             [isLandingPage]="false" [isChatbotModeActive]="isChatbotModeActive" [chatbotModes]="chatbotModes"></sabis-chatbot-input>
    </div>

    <!-- Connection status + Welcome message + Input + Warning -->
    } @else if (!isLoadingHistoryMessages && !isHistoryLoadingFailed) {
    <div class="no-messages">
        <!-- Connection status -->
        <h3>{{ connectionStatus }}</h3>
        @if (shouldShowRetryButton) {
        <sabis-retry-button [title]="'Retry'"
                            (retryClick)="startConnectionToChatbot()">
        </sabis-retry-button>
        }

        <!-- Welcome message -->
        <span class="welcome-message">Hi {{ userFirstName }}, how can I help you today?</span>

        <!-- Input Area -->
        <div class="chat-input-landing">
            <sabis-chatbot-input #inputComponent [hasActiveSession]="hasActiveSession" [isOutOfPrompts]="isOutOfPrompts" [isOutOfSessions]="isOutOfSessions"
                                 [maxChars]="maxChars" [disclaimerMessage]="disclaimerMessage" [canAddEquation]="canAddEquation" [isConnectionEstablished]="isConnectionEstablished"
                                 (sendMessage)="onSendMessage()" [isLandingPage]="true" [isChatbotModeActive]="isChatbotModeActive" [chatbotModes]="chatbotModes"></sabis-chatbot-input>
        </div>

        <!-- Warning message Area -->
        @if (this.sessionQuotaStatus?.showWarning) {
        <span class="warning-message">Be carefull, you still have 1 more session before reaching your daily limit.</span>
        }
    </div>
    }

    <!-- Warning message Area -->
    @if (this.promptQuotaStatus?.showWarning) {
    <span class="warning-message">Nearing limit - only 1 prompt left in this chat</span>
    }
</div>
